import { render, staticRenderFns } from "./editContract.vue?vue&type=template&id=6f52743d&scoped=true&"
import script from "./editContract.vue?vue&type=script&lang=js&"
export * from "./editContract.vue?vue&type=script&lang=js&"
import style0 from "./editContract.vue?vue&type=style&index=0&id=6f52743d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f52743d",
  null
  
)

export default component.exports